import { Injectable } from '@angular/core';
import { HttpParams, HttpHeaders, HttpClient } from '@angular/common/http';

import { environment } from '../../../environments/environment';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import * as moment from 'moment';

const TOKEN_KEY = 'token';
const USER_KEY = 'user';

@Injectable({
  providedIn: 'root'
})
export class TokenStorageService {

  private options: {
    headers?: HttpHeaders,
    observe?: 'body',
    params?: HttpParams,
    reportProgress?: boolean,
    responseType: any,
    withCredentials?: boolean
  };

  private _API_BASE_URL: string = environment['API_URL'];

  public regisE: string = null;
  public regisS: string = null;

  constructor(private authHttp: HttpClient) { }

  signOut(): void {
    window.sessionStorage.clear();
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
  }

  public saveToken(token: string): void {
    window.sessionStorage.removeItem(TOKEN_KEY);
    window.sessionStorage.setItem(TOKEN_KEY, token);
    localStorage.removeItem(TOKEN_KEY);
    localStorage.setItem(TOKEN_KEY, token);
  }

  public getToken(): string | null {
    //return window.sessionStorage.getItem(TOKEN_KEY);
    return localStorage.getItem(TOKEN_KEY)
  }

  public saveUser(user: any): void {
    window.sessionStorage.removeItem(USER_KEY);
    window.sessionStorage.setItem(USER_KEY, JSON.stringify(user));
    localStorage.removeItem(USER_KEY);

    localStorage.setItem(USER_KEY, JSON.stringify(user));
  }

  public getUser(): any {
    //const user = window.sessionStorage.getItem(USER_KEY);
    const user = localStorage.getItem(USER_KEY)
    if (user) {
      return JSON.parse(user);
    }
  }

  public getRol(): any {
    const user = localStorage.getItem(USER_KEY);
    if (JSON.parse(user).rol) {
      return JSON.parse(user).rol;
    }
    return 0;
  }
  
  public tascaEntrada(id, data, text): any {
   return this.authHttp.put<any>(this._API_BASE_URL + "registre-en-tx/"+id+"?data="+data+"&tx="+text, null)
      .pipe(map(response => response || []));
  }

  public entrada(id): any {
   return this.authHttp.put<any>(this._API_BASE_URL + "registre-es/"+id+"?data="+moment(new Date()).format("YYYY-MM-DD HH:mm")+"&io=E", null)
      .pipe(map(response => response || []));
  }

  public tascaSortida(id, data, text): any {
   return this.authHttp.put<any>(this._API_BASE_URL + "registre-es-tx/"+id+"?data="+data+"&tx="+text, null)
      .pipe(map(response => response || []));
  }

  public sortida(id): any {
   return this.authHttp.put<any>(this._API_BASE_URL + "registre-es/"+id+"?data="+moment(new Date()).format("YYYY-MM-DD HH:mm")+"&io=S", null)
      .pipe(map(response => response || []));
  }

  public teletre(id, teletreball) {
   return this.authHttp.put(this._API_BASE_URL + "registre-tele/" + id + "?data=" + moment(new Date()).format("YYYY-MM-DD HH:mm") + "&tele=" + teletreball, null)
      .pipe(map(response => response || []));
  }

  public darreraES(id): any {
   return this.authHttp.get<any>(this._API_BASE_URL + "registre-es/"+id)
      .pipe(map(response => response || []));
  }

}